import useMediaQuery from './useMediaQuery';

import breakpoints from '@values/breakpoints';

export default function useMaxWidthMediaQuery(breakpoint: keyof typeof breakpoints) {
  return useMediaQuery(`(max-width: ${breakpoints[breakpoint]}px)`);
}
